import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { withRouter } from 'react-router-dom';
import { Elements, StripeProvider } from 'react-stripe-elements';
import CheckoutForm from '../../Components/ProductRegistration/CheckoutForm';
import Page from 'Components/Page';
import config from 'Config/firebase';

const pageStyles = {
  pageWrapper: {
    paddingLeft: '5%',
    paddingRight: '5%',
  },
  container: {
    maxWidth: 600,
  },
};

function Checkout({ classes }) {
  return (
    <Page wrapperStyles={classes.pageWrapper}>
      <div className={classes.container}>
        <StripeProvider apiKey={config.stripe}>
          <Elements>
            <CheckoutForm />
          </Elements>
        </StripeProvider>
      </div>
    </Page>
  );
}

export default withRouter(withStyles(pageStyles)(Checkout));
